<template>
  <v-container style="height: 100%;">
    {{ report }}
    <div class="d-flex align-center">
      <v-text-field
        @input="SET_REPORT({ ...report, title: $event })"
        :value="report.title"
        class="mb-5"
        label="Otsikko"
        clearable
        hide-details
        style="max-width: 300px;"
      />
      <v-select
        label="Kausi"
        :value="report.season"
        @change="SET_REPORT({ ...report, season: $event })"
        item-value="id"
        item-text="season_name"
        style="max-width: 100px;"
        :items="seasons"
        class="mb-5 ml-1"
        :loading="loading_seasons"
        hide-details
      />
      <v-spacer></v-spacer>
      <v-btn
        small
        outlined
        @click="moddingFilter = true"
      >
        <v-icon>
          mdi-filter-variant
        </v-icon>
        Pääsuodatin
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            outlined
            class="ml-1"
            v-on="on"
            v-bind="attrs"
          >
            <v-icon>mdi-plus</v-icon>
            Lisää elementti
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="addItem('list')">
            Lista - Lyöntidata
          </v-list-item>
          <v-list-item @click="addItem('map')">
            Kartta
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        :disabled="!report.filter"
        outlined
        small
        :loading="loading_some"
        class="ml-1"
        @click="refreshData"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn @click="saveReport" small outlined class="ml-1" color="primary" :disabled="!dirty">
        Tallenna muutokset
      </v-btn>
    </div>
    <div class="pb-5">
      <v-chip label>
        {{ all_events.length }} tapahtumaa
      </v-chip>
    </div>
    <grid-layout
      :layout.sync="layout"
      :col-num="12"
      :row-height="30"
      :use-css-transforms="true"
      :responsive="true"
      style="width: 100%;"
    >
      <grid-item
        v-for="(item, i) in layout"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :is-draggable="true"
        :is-resizable="true"
        :i="item.i"
        :key="item.i"
      >
        <ReportItem
          :item="item"
          @delete="removeItem(i)"
          @update="updateItem($event, i)"
          :season_id="chosen_season"
        />
      </grid-item>
    </grid-layout>


    <CreateFilterDialog
      :show="moddingFilter"
      :loading="loading_seasons"
      :report="true"
      @close="moddingFilter = false"
      @search="SET_REPORT({ ...report, filter: $event }); moddingFilter = false"
    ></CreateFilterDialog>
  </v-container>
</template>

<script>
import CreateFilterDialog from '@/components/filters/CreateFilterDialog.vue';
import ReportItem from '@/components/report/ReportItem.vue';
import { mapActions, mapGetters } from 'vuex';
import { mapMutations } from 'vuex/dist/vuex.common.js';
import { v4 as uuidv4 } from 'uuid';
import { GridLayout, GridItem } from "vue-grid-layout"

export default {
  components: {
    CreateFilterDialog,
    ReportItem,
    GridLayout,
    GridItem
  },
  data: () => ({
    moddingFilter: false,
    chosen_season: null
  }),
  mounted() {
    this.RESET()

    this.initSeasons(this.leagueId)
      .then(ssns => {
        const season = ssns[0].id
        const filter = this.report.filter || { ...this.$refs.createFilter.getFilter(), league_id: this.leagueId, season }
        this.SET_REPORT({ ...this.report, filter, season })
      })
  },
  computed: {
    ...mapGetters('filter', [
      'all_events',
      'loading_some'
    ]),
    ...mapGetters('user', [
      'leagueId'
    ]),
    ...mapGetters('admin', [
      'seasons',
      'loading_seasons'
    ]),
    ...mapGetters('report', [
      'report',
      'dirty'
    ]),
    layout: {
      get() {
        return this.report.items;
      },
      set(val) {
        this.SET_REPORT({ ...this.report, items: val })
      }
    }
  },
  methods: {
    ...mapActions('filter', [
      'getFilterGames',
      'getGameEvents'
    ]),
    ...mapActions('noti', [
      'error'
    ]),
    ...mapActions('admin', [
      'initSeasons'
    ]),
    ...mapMutations('report', [
      'SET_REPORT',
      'RESET',
      'SET_DIRTY'
    ]),
    saveReport() {
      this.SET_DIRTY(false)
    },
    addItem(type) {
      const is = (this.report.items && this.report.items.length) ? this.report.items.map(i => parseInt(i.i)) : [0]
      const max = Math.max(...is)
      const items = this.report.items.concat({
        uuid: uuidv4(),
        "w": 4,
        "h": 4,
        "x": 0,
        "y": 0,
        "i": (max + 1).toString(),
        type,
      })

      this.SET_REPORT({ ...this.report, items })
    },
    removeItem(index) {
      this.SET_REPORT({ ...this.report, items: this.report.items.filter((_, i) => i !== index) })
    },
    updateItem(item, index) {
      const mod = { ...this.report }
      mod.items[index] = { ...item }
      this.SET_REPORT(mod)
    },
    refreshData() {
      this.getFilterGames({ filter: JSON.stringify(this.report.filter) })
        .then(async e => {
          const proms = e.games.map(g => {
            return this.getGameEvents({ game_id: g.id })
          })

          await Promise.all(proms)
        })
        .catch(e => {
          this.error(e)
        })
    }
  },
  watch: {
    'report': {
      handler() {
        this.SET_DIRTY(true)
      },
      deep: true
    }
  },
}
</script>